var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['mobile-verification-code', _vm.m > 0 ? '' : 'get'],on:{"click":_vm.getSmsCode}},[_vm._v(" "+_vm._s(_vm.m > 0 ? _vm.m + "s后重新发送" : "获取动态码")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }